// import React from "react";
// import ExploreProgram from "../Program/ExploreProgram";

// const RssFeed = () => {
//   return (
//     <div className="mt-24">
//         <ExploreProgram />
//     </div>
//   );
// };

// export default RssFeed;
import React, { useEffect, useState } from "react";

function RSSFeed() {
  const [xmlData, setXmlData] = useState("");
  const feedUrl = "https://rss.nytimes.com/services/xml/rss/nyt/HomePage.xml";

  useEffect(() => {
    fetch(feedUrl)
      .then((res) => res.text())
      .then((str) => {
        setXmlData(str);
      })
      .catch((err) => console.error("Error loading RSS feed:", err));
  }, []);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>RSS Feed XML</h2>
      {xmlData ? (
        <pre
          style={{
            // background: "#1e1e1e",
            // color: "#dcdcdc",
            padding: "15px",
            borderRadius: "8px",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            maxHeight: "80vh",
            overflowY: "auto",
            fontSize: "14px",
            fontFamily: "Courier New, monospace",
            marginTop: "60px",
          }}
        >
          {xmlData}
        </pre>
      ) : (
        <p>Loading XML...</p>
      )}
    </div>
  );
}

export default RSSFeed;
